module.exports = __webpack_public_path__ + "img/logo.555c05fc.png";